import React, { useState, useEffect, useRef } from 'react';
import Network from './Requests';
import { Stack, Button, Alert } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import ViewStart from './ViewStart';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useSelector, useDispatch } from 'react-redux';
import { openShare, closeShare } from '../store/reducers/shareSlice';
import { globalConfig } from '../configuration/config';
import { Snackbar } from '@mui/material';
import { useTranslation } from "react-i18next";

const Share = ({ variantGuid, chats, companyId }) => {
  const dispatch = useDispatch();
  const isShareOpen = useSelector((state) => state.share.isShareOpen);
  const linkGuid = useSelector((state) => state.share.linkGuid);
  // Отображаем компонент только если он открыт

  const qrRef = useRef();
  const [time, setTime] = useState('1');
  const [user, setUser] = useState('Клиент ' + new Date().toLocaleString());
  const [type, setType] = useState('Graphics');
  const [userChatGuid, setUserChatGuid] = useState('');
  const [actor, setActor] = useState('');
  const [actorClose, setActorClose] = useState(true);
  const [template, setTemplate] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tempText, setTempText] = useState('');
  const [selectText, setSelectText] = useState('');
  const [changeModal, setChangeModal] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectIndex, setSelectIndex] = useState(0);
  const [qr, setQr] = useState();
  const [email, setEmail] = useState('');
  const [viber, setViber] = useState('');
  const [sms, setSms] = useState('');
  const [hasChanges, setHasChanges] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [statusType, setStatusType] = useState(''); // 'success' | 'error'
  const { t } = useTranslation();

  const statusRef = useRef(null);
  useEffect(() => {
    if (statusMessage && statusRef.current) {
      statusRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [statusMessage]);

  useEffect(() => {
    if (!linkGuid) return;

    setHasChanges(true); // любые изменения при наличии linkGuid
  }, [user, time, type, actor]);

  useEffect(() => {
    const fetchLinkData = async () => {
      if (!linkGuid) return;

      try {
        const response = await fetch(
          `${globalConfig.config.common.api}/StructureUrls/GetStructureUrl?structureUrl=${linkGuid}`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );

        if (!response.ok) throw new Error('Ошибка при получении данных');

        const data = await response.json();

        if (data.guidCalculation) {
          setUserChatGuid(data.chatGuid || '');
          setUser(data.userName || 'Клиент');
          setQr(`https://2dchat.system123.ru/web/project/?id=${linkGuid}`);
          setActor(String(data.actorNumber ?? ''));
          setType(data.type || 'Graphics');
          setTime(String(data.lifeTimeHours || '1'));

          qrRef.current?.classList.add('visible');
        }
      } catch (err) {
        console.error('Ошибка при запросе linkGuid:', err);
      }
    };

    fetchLinkData();
  }, [linkGuid]);

  useEffect(() => {
    const actorHandler = (e) => {
      if (e.data.type === 'actor') {
        setActor(e.data.value);
        setActorClose(false);
      }
    };

    window.addEventListener('message', actorHandler);
    chats.forEach((chat) => {
      if (chat.type === '1') {
        setUserChatGuid(chat.guid);
      }
    });

    return () => window.removeEventListener('message', actorHandler);
  }, []);

  useEffect(() => {
    chats.forEach((chat) => {
      if (chat.type === '1') {
        setUserChatGuid(chat.guid);
      }
    });
  }, [chats, variantGuid, companyId]);

  const handleChangeText = (e) => {
    const { name, value } = e.target;
    if (name === 'user') setUser(value);
    if (name === 'time') setTime(value);
    if (name === 'email') setEmail(value);
    if (name === 'viber') setViber(value);
    if (name === 'sms') setSms(value);
  };

  const clear = () => {
    document.querySelectorAll('[data-clear]').forEach((elem) => (elem.value = ''));
    qrRef.current?.classList.remove('visible');
  };

  const sendMessage = async (type, address) => {
    const fn = {
      email: 'InviteEmail',
      viber: 'InviteViber',
      sms: 'InviteSms',
    }[type];

    await new Network()[fn](userChatGuid, variantGuid, address, user, time, type, actor, tempText);
    clear();
    dispatch(closeShare());
  };

  const copyLink = () => {
    const copyText = document.getElementById('copyLink');
    navigator.clipboard.writeText(copyText.value);
    document.getElementById('TooltipText').innerHTML = 'Скопировано';
  };

  const outFunc = () => {
    document.getElementById('TooltipText').innerHTML = 'Копировать';
  };

  const openQR = async (e) => {
    e.preventDefault();

    const chat = chats.find((c) => c.type === 1);
    if (!chat) {
      console.warn('Нет чата с type=1');
      return;
    }

    try {
      const send = await new Network().CreateQRCodeLink(
        chat.guid,
        variantGuid,
        user,
        time,
        type,
        actor,
      );
      setUserChatGuid(chat.guid);
      setQr(send.url);
      qrRef.current?.classList.add('visible');
    } catch (err) {
      console.error('Ошибка при создании QR', err);
    }
  };

  const openBox = async () => {
    setLoading(true);
    const template = await new Network().GetAllTemplate(companyId);
    setTemplate(template);
    setTempText(template[0]?.content || '');
    setSelectText(template[0]?.content || '');
    setLoading(false);
  };

  const handleSelectTemp = async (e, index) => {
    document.querySelectorAll('.template-sms--item').forEach((el) => el.classList.remove('active'));
    e.target.classList.add('active');
    setTempText(template[index].content);
    setSelectText(template[index].content);
    setSelectIndex(index);
  };

  const handleChange = (e) => {
    setTempText(e.target.value);
  };

  const changeTemplate = () => {
    if (tempText !== selectText) setChangeModal(true);
  };

  const saveTemplate = () => {
    if (tempText !== selectText) setSaveModal(true);
  };

  const deleteTemplate = () => {
    setDeleteModal(true);
  };

  const handleChangeSave = async () => {
    const id = document
      .getElementsByClassName('template-sms--item')
      [selectIndex].getAttribute('data-id');
    await new Network().templateUpdate(id, tempText, companyId);
    const updatedTemplates = [...template];
    updatedTemplates[selectIndex].content = tempText;
    setTemplate(updatedTemplates);
    setChangeModal(false);
  };

  const handleTemplateDelete = async () => {
    const id = document
      .getElementsByClassName('template-sms--item')
      [selectIndex].getAttribute('data-id');
    await new Network().templateDelete(Number(id));
    const newTemplate = [...template];
    newTemplate.splice(selectIndex, 1);
    setTemplate(newTemplate);
    setTempText(newTemplate[0]?.content || '');
    setSelectIndex(0);
    setDeleteModal(false);
    if (newTemplate.length > 0) {
      document.getElementsByClassName('template-sms--item')[0].classList.add('active');
    }
  };

  const handleTemplateSave = async () => {
    const name = document.querySelector('.save-template [name="name"]').value;
    const type = document.querySelector('.save-template [name="type"]').value;
    if (!name) {
      alert('Имя шаблона не заполнено');
      return;
    }
    const newTemplate =
      type === '2'
        ? await new Network().templateSave(name, tempText, companyId)
        : await new Network().templateSave(name, tempText);

    const updatedTemplates = [
      ...template,
      {
        name,
        content: tempText,
        id: newTemplate.id,
        idCompany: newTemplate.idCompany,
      },
    ];
    setTemplate(updatedTemplates);
    setSelectIndex(updatedTemplates.length - 1);
    setSaveModal(false);
  };

  const handleSaveLink = async () => {
    if (!linkGuid || !hasChanges) return;

    try {
      const res = await fetch(
        `${globalConfig.config.common.api}/StructureUrls/UpdateStructureUrl`,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            chatGuid: userChatGuid,
            guidCalculation: linkGuid,
            userName: user,
            extraUrlParams: '',
            lifeTimeHours: Number(time),
            actorNumber: Number(actor),
            type,
            room: '',
            structureUrl: linkGuid,
          }),
        },
      );

      if (!res.ok) {
        const text = await res.text();
        showStatus(text || 'Ошибка при сохранении', 'error');
        return;
      }

      showStatus('Ссылка успешно обновлена', 'success');
      setHasChanges(false);
    } catch (err) {
      console.error('Ошибка при сохранении:', err);
      showStatus('Ошибка при сохранении', 'error');
    }
  };

  const showStatus = (message, type) => {
    setStatusMessage(message);
    setStatusType(type);

    setTimeout(() => {
      setStatusMessage('');
      setStatusType('');
    }, 3000);
  };

  if (!isShareOpen) return null;

  return (
    <>
      <Snackbar
        open={saveSuccess}
        autoHideDuration={3000}
        onClose={() => setSaveSuccess(false)}
        message={t('share.snackbar.linkUpdated')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ zIndex: 20000 }}
      />

      <Snackbar
        open={!!errorMessage}
        autoHideDuration={3000}
        onClose={() => setErrorMessage('')}
        message={errorMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ zIndex: 20000 }}
      />

      {!isShareOpen ? null : (
        <Dialog open={isShareOpen} onClose={() => dispatch(closeShare())} maxWidth="sm" fullWidth>
          <div
            className="share"
            style={{
              padding: '24px',
              boxSizing: 'border-box',
            }}
          >
            <div className="infoList--title">{t('share.titleInviteClient')}</div>

            <div className="share--item">
              <span className="input-title">{t('share.input.clientName')}</span>
              <input type="text" name="user" value={user} data-clear="" onChange={handleChangeText} />
            </div>

            <div className="share--item share--item--qr share--item--qr--long">
              <span className="input-title">{t('share.input.linkLifetimeHours')}</span>
              <form onSubmit={openQR}>
                <input
                  className="share--item-input"
                  type="text"
                  name="time"
                  value={time}
                  data-clear=""
                  onChange={handleChangeText}
                />
                <button type="submit">{t('share.button.getQR')}</button>
              </form>
            </div>

            <div className="template-sms">
              <Accordion onChange={(e, exp) => (exp ? openBox() : null)}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}> 
                  <Typography>
                    {t('share.accordion.text')} {loading && <CircularProgress size={16} sx={{ ml: 1 }} />}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <textarea value={tempText || ''} onChange={handleChange} />
                  <div className="template-sms--List">
                    <div className="template-sms--action">
                      <button onClick={changeTemplate}>{t('share.template.change')}</button>
                      <button onClick={saveTemplate}>{t('share.template.save')}</button>
                      <button onClick={deleteTemplate}>{t('share.template.delete')}</button>
                    </div>
                    {template.map((c, i) => (
                      <div
                        key={c.id}
                        data-id={c.id}
                        className={'template-sms--item ' + (i === selectIndex ? 'active' : '')}
                        onClick={(e) => handleSelectTemp(e, i)}
                      >
                        {i + 1} - {c.name}
                        {c.idCompany > 0 && <span className="companyTemp">К</span>}
                      </div>
                    ))}
                  </div>
                </AccordionDetails>
              </Accordion>

              {/* Модалки */}
              <Dialog open={changeModal} onClose={() => setChangeModal(false)}>
                <DialogContent>
                  <DialogContentText>{t('share.modal.changeTemplateQuestion')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                  <div className="button" onClick={handleChangeSave}>{t('common.yes')}</div>
                  <div className="button" onClick={() => setChangeModal(false)}>{t('common.no')}</div>
                </DialogActions>
              </Dialog>

              <Dialog open={saveModal} onClose={() => setSaveModal(false)}>
                <DialogContent>
                  <form className="save-template">
                    <input type="text" name="name" placeholder={t('share.modal.saveTemplate.namePlaceholder')} />
                    <select name="type">
                      <option value="1">{t('share.templateType.user')}</option>
                      {companyId > 0 && <option value="2">{t('share.templateType.company')}</option>}
                    </select>
                  </form>
                </DialogContent>
                <DialogActions>
                  <div className="button" onClick={handleTemplateSave}>{t('common.yes')}</div>
                  <div className="button" onClick={() => setSaveModal(false)}>{t('common.no')}</div>
                </DialogActions>
              </Dialog>

              <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
                <DialogContent>
                  <DialogContentText>{t('share.modal.deleteTemplateQuestion')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                  <div className="button" onClick={handleTemplateDelete}>{t('common.yes')}</div>
                  <div className="button" onClick={() => setDeleteModal(false)}>{t('common.no')}</div>
                </DialogActions>
              </Dialog>
            </div>

            <ViewStart type={type} onChangeType={setType} actorOpen={actorClose} />

            {qr && (
              <div className="qr-view visible" ref={qrRef}>
                <QRCodeSVG value={qr} renderAs="svg" />
                <input id="copyLink" disabled value={qr} />
                <div className="tooltip">
                  <i onClick={copyLink} onMouseOut={outFunc}>
                    <span className="tooltiptext" id="TooltipText">{t('share.tooltip.copy')}</span>
                  </i>
                </div>
              </div>
            )}

            {['email', 'viber', 'sms'].map((field) => (
              <div key={field} className="share--item">
                <span className="input-title">{field.toUpperCase()}</span>
                <form
                  className="input-with-button"
                  onSubmit={(e) => {
                    e.preventDefault();
                    sendMessage(field, eval(field));
                  }}
                >
                  <input type="text" name={field} data-clear="" onChange={handleChangeText} />
                  <button type="submit">{t('share.button.send')}</button>
                </form>
              </div>
            ))}

            <div
              className="buttons-menu center"
              ref={statusRef}
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
                {linkGuid && (
                  <button onClick={handleSaveLink} disabled={!hasChanges}>
                    {t('share.button.save')}
                  </button>
                )}
                <button onClick={() => dispatch(closeShare())}>{t('share.button.close')}</button>
              </div>

              {statusMessage && (
                <div
                  style={{
                    marginTop: '4px',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    backgroundColor: statusType === 'success' ? '#d4edda' : '#f8d7da',
                    color: statusType === 'success' ? '#155724' : '#721c24',
                    border: `1px solid ${statusType === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                    fontSize: '14px',
                    textAlign: 'center',
                    maxWidth: '300px',
                  }}
                >
                  {statusMessage}
                </div>
              )}
            </div>
          </div>
        </Dialog>
      )}
    </>
  );

};

export default Share;
